import React, { Component } from 'react';
import { fbgWebMasterAccess } from '../../services/access/index';

class FbgAccessContainer extends Component {
    render() {
        return this.props.children;
    }

}

export default fbgWebMasterAccess(FbgAccessContainer);


// WEBPACK FOOTER //
// ./web/src/components/access/FbgAccessContainer.js